import React from 'react';
import {Disclosure, RadioGroup, Switch} from '@headlessui/react';
import clsx from 'clsx';
import * as R from 'ramda';
import {Link} from 'components/Link';
import {useLoaderData, useLocation} from '@remix-run/react';

//domains
import {
  type FilterOption as FilterOptionType,
  type PriceRange,
} from 'domains/collections';
import {loader} from '~/routes/($lang)/collections/$collectionHandle';

//components
import RelatedCollections from './RelatedCollections';
import FilterOption from './FilterOption';
import SelectedOptions from './SelectedOptions';

export default function CollectionFilter({type}: {type?: string}) {
  const {filter, translation} = useLoaderData<typeof loader>();
  const {pathname} = useLocation();

  const filterTranslation = translation.filter as any;

  return (
    <div className="mobile-menu h-full overflow-hidden overflow-y-scroll px-5 pb-20 md:px-0 md:pb-0">
      {/* <div className="">
        <span className="md:hidden">Filtering options:</span>
        <span className="hidden md:block">Filter(s) Selected:</span>
      </div>
      <SelectedOptions /> */}
      <div className="grid gap-[26px]">
        {/* related collections */}
        {type && type === 'serach' && (
          <div className="border-b-[1px] border-solid border-black">
            <div className="md:hidden">
              {pathname !== '/collections/vendor' ? (
                <RelatedCollections />
              ) : null}
            </div>
            <div className="hidden md:block">
              {pathname !== '/collections/vendor' ? (
                <RelatedCollections />
              ) : null}
            </div>
          </div>
        )}
        {filter &&
          filter.options &&
          filter.options
            .filter(
              (o: FilterOptionType) => o.filterOptionId !== 'pf_vp_price_old',
            )
            .map((o: FilterOptionType, index: number) => {
              const hasOptions = o.values && !R.isEmpty(o.values);
              if (!hasOptions) {
                return null;
              }
              if (o.filterType === 'price') {
                const priceRange = o.values as PriceRange;
                if (priceRange.max === priceRange.min) {
                  return null;
                }
              }
              const translatedLabel = filterTranslation[o.label] ?? o.label;
              return (
                <div
                  key={`${o.filterOptionId}-${index}`}
                  className="border-b-[1px] border-solid border-black"
                >
                  <div className="md:hidden">
                    <Disclosure defaultOpen={!o.isCollapsePC}>
                      {({open}) => (
                        <>
                          <Disclosure.Button className="flex w-full items-center justify-between pt-2 pb-4 text-left">
                            <div className="">{translatedLabel}</div>
                            {open ? (
                              <svg
                                width="13"
                                height="3"
                                viewBox="0 0 13 3"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                                  fill="black"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                          </Disclosure.Button>
                          <Disclosure.Panel
                            className={clsx([
                              'text-gray-500 my-2',
                              o.values &&
                                Array.isArray(o.values) &&
                                o.values.length > 9 &&
                                'md:max-h-[400px] md:overflow-scroll',
                            ])}
                          >
                            <FilterOption o={o} />
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  </div>
                  <div className="hidden md:block">
                    <Disclosure defaultOpen={!o.isCollapseMobile}>
                      {({open}) => (
                        <>
                          <Disclosure.Button className="flex w-full items-center justify-between pt-2 pb-4 text-left">
                            <div className="">{translatedLabel}</div>
                            {open ? (
                              <svg
                                width="13"
                                height="3"
                                viewBox="0 0 13 3"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                                  fill="black"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                          </Disclosure.Button>
                          <Disclosure.Panel
                            className={clsx([
                              'text-gray-500 my-2',
                              o.values &&
                                Array.isArray(o.values) &&
                                o.values.length > 9 &&
                                'md:max-h-[400px] md:overflow-scroll',
                            ])}
                          >
                            <FilterOption o={o} />
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  </div>
                </div>
              );
            })}
      </div>
    </div>
  );
}
